import {SET_USER_VIEW_MODE} from 'constants/action-types.js';
import {SET_CURRENT_USER_MIX} from 'constants/action-types.js';
import {SET_USER_HAS_EDITS_TO_SAVE} from 'constants/action-types.js';
import {SET_LOADED_TRACKS} from 'constants/action-types.js';
import {SPOTLIGHT} from 'constants/user-view-modes.js';
import {SET_BPM} from 'constants/action-types.js';
import {SET_SPOTLIGHT_TRACKS} from 'constants/action-types.js';

let initialState = {
    viewMode: SPOTLIGHT,
    currentMix: undefined,
    hasEditsToSave: false,
    loadedTracks: [],
    bpm: 120,
    spotlightTracks: [],
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_USER_VIEW_MODE:
        return {... state,
                viewMode: action.payload
        };
    case SET_CURRENT_USER_MIX:
        return {... state,
                currentMix: action.payload
        };
    case SET_USER_HAS_EDITS_TO_SAVE:
        return {... state,
                hasEditsToSave: action.payload
        };
    case SET_LOADED_TRACKS:
        return {
            ... state,
            loadedTracks: action.payload
        };
    case SET_BPM:
        return {
            ... state,
            bpm: action.payload
        };
    case SET_SPOTLIGHT_TRACKS:
        return {
            ... state,
            spotlightTracks: action.payload
        };
    default:
        return state;
    }
}

export default userReducer;
 
